document.addEventListener("DOMContentLoaded", function () {
   if (window.innerWidth <= 749) {
  setTimeout(function () {
    $('.related-products ul.grid.product-grid').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      dots: false
    });
  }, 2500); // 3000ms delay before initializing Slick slider
   }
});


